/**
 * Addsearch element ids
 */
export const searchIds = {
	autocompleteId: 'addsearch-ui-autocomplete',
	resultsId: 'addsearch-ui-results',
	fieldId: 'addsearch-ui-field',
	datalistId: 'addsearch-ui-datalist',
};
